import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../../utils/common'
import LinkWithStatus from '../../../common/LinkWithStatus'
import { deleteRequest, getRequest } from '../../../../services/base'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import Pagination from '../../../common/Pagination'
import Tooltip from '../../../common/tooltip'
import NoRecordsFound from '../../../common/NoRecordsFound'
import SystemEditCreateForm from './form'
import { createSearchParams } from 'react-router-dom'
import { getLocalStorageData } from '../../../../utils/LocalStorageAccess'

const SystemRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="w-2/12 pl-10">{formatEmptyValue(props.system_id)}</div>
        <div className="flex w-6/12 items-center table_text">
          <Tooltip position={'top'} message={props.name}>
            <div>{props.name}</div>
          </Tooltip>
        </div>
        <div className="w-2/12">{formatEmptyValue(props.make)}</div>

        <div className="flex w-2/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const System = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const [systemListData, setSystemListData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [selectedSystem, setSelectedSystem] = useState({})
  const vehicle_redirect_url = getLocalStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getLocalStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    getSystemList(null)

    dispatch({
      type: 'header',
      data: {
        header: 'System',
        sub_header: 'Can be configure system data from here',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getSystemList = async (url = null) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching System`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(
      url ? url : `/api/system/?search=${searchValue}`
    )
    setSystemListData(response.results)
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deletePlant = async (plant_obj) => {
    if (
      window.confirm(`Are you sure you want to Delete ${plant_obj.name} Plant`)
    ) {
      let res = await deleteRequest(`/api/system/${plant_obj.id}/`)
      getSystemList(null)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `System Deleted Successfully`,
        },
      })
    }
  }

  return (
    <>
      <SystemEditCreateForm
        showModal={showModal}
        setShowModal={setShowModal}
        getSystemList={getSystemList}
        selectedSystem={selectedSystem}
        onSave={() => {
          getSystemList()
          setShowModal(false)
        }}
        onClose={() => {
          setSelectedSystem({})
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getSystemList(null)
        }}
      >
        <div className="flex space-x-5">
          <div className="w-1/3">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
              placeholder="Enter to search"
              type="search"
              name="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value)
              }}
            />
          </div>
          <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
            Search
          </button>

          <div className="w-2/3 font-light text-right space-x-5">
            <LinkWithStatus
              href={`/administration/system/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New System"
              onClickFunc={() => {
                setSelectedSystem({})
                setShowModal(true)
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">ID</div>
          <div className="w-6/12">Name</div>
          <div className="w-2/12">Make Details</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {systemListData?.map((system, index) => {
        return (
          <SystemRow
            {...system}
            key={`system-${index}`}
            onEdit={() => {
              setSelectedSystem(system)
              setShowModal(true)
            }}
            onDelete={() => {
              deletePlant(system)
            }}
          />
        )
      })}

      {systemListData?.length < 1 && (
        <NoRecordsFound caption={"System's Not Found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getSystemList(e)
          }}
          onClickPrev={(e) => {
            getSystemList(e)
          }}
        />
      </div>
    </>
  )
}

export default System
